import {
  ResponsiveModal,
  ResponsiveModalContent,
} from "@/kit/ui/responsive-modal";
import { StateProvider, useStateContext } from "./state";
import { InferContents } from "./InferContents";
import { UploadContents } from "./UploadContents";

interface InnerModalProps {
  onClose: () => void;
}

const InnerModal = ({ onClose }: InnerModalProps) => {
  const { uploading, cancelUpload } = useStateContext();
  return (
    <ResponsiveModal
      open
      onOpenChange={(open) => {
        if (!open) {
          if (uploading) {
            cancelUpload();
          } else {
            onClose();
          }
        }
      }}
    >
      <ResponsiveModalContent
        className={
          uploading
            ? ""
            : "lg:max-w-(--breakpoint-lg) md:container md:mx-auto w-full max-h-full px-6 flex flex-col gap-6"
        }
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        {uploading ? <UploadContents /> : <InferContents />}
      </ResponsiveModalContent>
    </ResponsiveModal>
  );
};

export interface ModalProps {
  files: File[];
  datasetVersionId: string;
  onClose: () => void;
}

export const Modal = ({ files, datasetVersionId, onClose }: ModalProps) => {
  return (
    <StateProvider files={files} datasetVersionId={datasetVersionId}>
      <InnerModal onClose={onClose} />
    </StateProvider>
  );
};
